import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import React from 'react';
import Webcam from 'react-webcam';

import Button from 'components/Button';

import { VIDEO_CONSTRAINTS } from './video-constraints.data';

interface IProps {
  webcamRef: any;
  isOpen: boolean;
  onClose: () => void;
  onCapture: () => void;
}

const WebCam: React.FC<IProps> = ({ webcamRef, isOpen, onClose, onCapture }) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Take Picture</ModalHeader>
        <ModalCloseButton />
        <ModalBody p="6" display="flex" flexDirection="column" alignItems="center">
          <Webcam
            audio={false}
            height={720}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            width={1280}
            videoConstraints={VIDEO_CONSTRAINTS}
          />
          <Button type="submit" colorScheme="secondary" onClick={onCapture} mt={4}>
            Capture
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default WebCam;
